import { Module } from "vuex";

export const accountStore: Module<any, any> = {
  state: {
    ribbonOnProfiles: "",
    activeProfiles: "",
    testMode: false,
    listParametersActivated: [],
  },
  getters: {
    activeProfiles: (state) => state.activeProfiles,
    ribbonOnProfiles: (state) => state.ribbonOnProfiles,
    testMode: (state) => state.testMode,
    env: (state) => {
      if (state.activeProfiles.indexOf("dev") > -1 || state.activeProfiles.indexOf("test") > -1) {
        console.log("[ONLY IN DEV / TEST ENV / ADMIN]");
        return true;
      } else if (state.userIdentity !== null) {
        if (state.userIdentity.login == "admin") return true;
      }
    },
    prod: (state) => state.activeProfiles.indexOf("prod") > -1,
    listParametersActivated: (state) => state.listParametersActivated,
  },
  mutations: {
    setActiveProfiles(state, profile) {
      state.activeProfiles = profile;
    },
    setRibbonOnProfiles(state, ribbon) {
      state.ribbonOnProfiles = ribbon;
    },
    switchTestMode(state, value) {
      console.log("TEST MODE:", value);
      state.testMode = value;
    },
    listParametersActivated(state, values) {
      state.listParametersActivated = values;
    },
  },
};
